import styled from 'styled-components';

const NavigationControlContainer = styled.div`
  position: absolute;
  right: 40px;
  top: 10px;
  z-index: 1;

  .mapboxgl-ctrl {
    margin: 0;
  }
`;

export default NavigationControlContainer;
